import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { PageSeo } from '@/components/SEOHead'
import { resolveRouteSeo } from '@/lib/seo/resolveRouteSeo'

/** Route-level SEO that renders before lazy pages and API responses finish loading. */
export function RouteSeoFallback() {
  const { pathname, search } = useLocation()
  const seo = useMemo(() => resolveRouteSeo(pathname, search), [pathname, search])
  return <PageSeo seo={seo} />
}
